/* WJW Increment 48 — ParcelWILL duplicate native mount guard.
 * Observed on the actual Increment 47 /cart DOM: TWO identical #return-widget
 * controls in #Cart collaterals, plus ONE independent drawer widget.
 * Keep ONE real cart-page node; do not clone controls, click the vendor switch,
 * change fee products, or interfere with the drawer's independent widget.
 * Increment 28 remains solely responsible for moving the surviving native
 * control among Order Summary / floating checkout / bottom checkout.
 */
(() => {
  'use strict';
  if (window.__wjw48ProtectionDedupe) return;
  window.__wjw48ProtectionDedupe = true;
  if (!document.body.classList.contains('template-cart')) return;

  let queued = false;
  function dedupe() {
    queued = false;
    const cart = document.querySelector('body.template-cart #Cart');
    if (!cart) return;
    const nodes = Array.from(cart.querySelectorAll('[id="return-widget"]'))
      .filter(node => node.querySelector('.return-widget-button'));
    if (nodes.length < 2) return;

    // Preserve the actual native control already being moved by Increment 28.
    // Otherwise prefer the vendor's original .return-insurance wrapper.
    const keep = nodes.find(node => node.closest('[data-wjw-protection-slot]')) ||
      nodes.find(node => node.parentElement?.classList.contains('return-insurance')) ||
      nodes[0];
    nodes.forEach(node => {
      if (node === keep) return;
      const parent = node.parentElement;
      if (parent?.classList.contains('return-insurance') && parent.children.length === 1) {
        parent.remove();
      } else {
        node.remove();
      }
    });
    // No synthetic click and no direct cart mutation. This event is diagnostic
    // only; the vendor/Inc28 observers continue handling real state changes.
    document.dispatchEvent(new CustomEvent('wjw:protection-deduplicated', {
      detail: { removed: nodes.length - 1 }
    }));
  }
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(dedupe);
  }
  function boot() {
    const cart = document.querySelector('body.template-cart #Cart');
    if (!cart) return;
    new MutationObserver(schedule).observe(cart, { childList: true, subtree: true });
    document.addEventListener('cart:refresh', schedule);
    document.addEventListener('line-item:change:end', schedule);
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
